export const project = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        project:'Project',
        project_information:'Project Information',
        project_id:'Project Id',
        project_onboarding:'Project Onboarding',
        add_project:'Add project',
        edit_project:'Edit project',
        project_description:'Project Description',
        project_name:'Project Name',
        status:'Status',
        accuracy_in_meter:'Accuracy In Meter',
        company_logo:"Company logo",
        delete_confrim_msg:"Are you sure you want to delete this project?"
    },
    ar: {
        project:'المشروع',
        project_information:'معلومات المشروع',
        project_id:'معرف المشروع',
        project_onboarding:'إعداد المشروع',
        add_project:'أضف المشروع',
        edit_project:'تحرير المشروع',
        project_description:'وصف المشروع',
        project_name:'اسم المشروع',
        status:'الحالة',
        accuracy_in_meter:'الدقة بالمتر',
        company_logo:"شعار الشركة",
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا المشروع؟"
    }
}
